/** @jsxImportSource solid-js */
import type { JSX } from "solid-js";
import { classes } from "#palette/style/index.solid";

export function Callout(props: {
  containerClasses: string;
  title: string;
  children: JSX.Element;
}) {
  const theseClasses = classes(
    `p-3 my-3 border rounded-lg flex gap-5`,
    props.containerClasses,
  );
  return (
    <div class={theseClasses}>
      <div class="grow">
        <strong class="text-lg">{props.title}</strong>
        <div class="flex flex-col gap-2">{props.children}</div>
      </div>
    </div>
  );
}

export function ErrorCallout(props: { title: string; children: JSX.Element }) {
  return (
    <Callout
      containerClasses="bg-status-error-bg text-status-error-fg border-status-error-fg"
      title={props.title}
    >
      {props.children}
    </Callout>
  );
}

export function WarningCallout(props: {
  title: string;
  children: JSX.Element;
}) {
  return (
    <Callout
      containerClasses="bg-status-warning-bg text-status-warning-fg border-status-warning-fg"
      title={props.title}
    >
      {props.children}
    </Callout>
  );
}

export function InfoCallout(props: { title: string; children: JSX.Element }) {
  return (
    <Callout
      containerClasses="bg-status-info-bg text-status-info-fg border-status-info-fg"
      title={props.title}
    >
      {props.children}
    </Callout>
  );
}
